import { canAccessRouteQuoteStep } from "@/router/middleware/beforeEnter/beforeEnterQuoteSteps";
import { IRouterConfig } from "@/types";
import { metaWithRoles } from "./constants/quoteMeta";

const breadcrumbs = [
  {
    link: "/quotes",
    title: "Quotes"
  }
];

export const CompanyAndLineOfBusiness: IRouterConfig = {
  path: "/quotes/create-draft",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/LineOfBusiness.vue"
    ),
  meta: {
    breadcrumbs,
    ...metaWithRoles,
    metaTags: {
      title: "Line Of Business Selection"
    },
    pageTitle: "Create Draft Quote"
  }
};

export const RiskAddress: IRouterConfig = {
  name: "risk-address-step",
  path: "risk-address",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/RiskAddress.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId,
    showCoApplicant: route.params.showCoApplicant
  }),
  meta: {
    breadcrumbs,
    ...metaWithRoles,
    pageTitle: "Specify Risk Address",
    metaTags: {
      title: "Edit Draft Quote"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const Territory: IRouterConfig = {
  name: "territory",
  path: "territory",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/TerritoryLookup.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    ...metaWithRoles,
    pageTitle: "Territory",
    metaTags: {
      title: "County Territory Information"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const PropertyRating: IRouterConfig = {
  name: "property-rating",
  path: "property-rating",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/PropertyRating.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    ...metaWithRoles,
    pageTitle: "Property Rating",
    metaTags: {
      title: "Property Rating"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const PropertyRatings: IRouterConfig = {
  name: "property-ratings",
  path: "property-ratings",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/PropertyRatings.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    ...metaWithRoles,
    pageTitle: "Property Ratings",
    metaTags: {
      title: "Property Ratings"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const RatingApplication: IRouterConfig = {
  name: "rating-application",
  path: "rating-application",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/RatingApplication/Application.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    ...metaWithRoles,
    pageTitle: "Rating Application",
    metaTags: {
      title: "Rating Application"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const UnderwritingQualifications: IRouterConfig = {
  name: "underwriting-qualifications",
  path: "underwriting-qualifications",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/UnderwritingQualifications.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    pageTitle: "Underwriting Qualifications",
    ...metaWithRoles,
    metaTags: {
      title: "Underwriting Qualifications"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const LossReportViewer: IRouterConfig = {
  name: "loss-report",
  path: "loss-report",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/LossReport.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    pageTitle: "Loss Reports",
    ...metaWithRoles,
    metaTags: { title: "Loss Reports" }
  },
  beforeEnter: canAccessRouteQuoteStep
};

export const RemarksAndMortgages: IRouterConfig = {
  name: "remarks-and-mortgages",
  path: "remarks-and-mortgages",
  component: () =>
    import(
      /* webpackChunkName: "quotes-step" */ "@/views/shared/quotes/RemarksAndMortgages.vue"
    ),
  props: (route: any) => ({
    quoteId: route.params.quoteId
  }),
  meta: {
    breadcrumbs,
    pageTitle: "Remarks & Mortgages",
    ...metaWithRoles,
    metaTags: {
      title: "Remarks & Mortgages"
    }
  },
  beforeEnter: canAccessRouteQuoteStep
};
